import { LayoutComponent }              from '../layout/layout.component';

import { LoginComponent }               from './user/login/login.component';
import { SignupComponent }              from './user/signup/signup.component';
import { LockComponent }                from './user/lock/lock.component';
import { RecoverComponent }             from './user/recover/recover.component';

import { AuthGuardService }             from '../services/auth-guard/auth-guard.service';

export const routes = [{
  path: '',
  component: LayoutComponent,
  children: [
    {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full',
      canActivate: [AuthGuardService]
    }, {
      path: 'dashboard',
      canActivate: [AuthGuardService],
      loadChildren: './dashboard/dashboard.module#DashboardModule'
    }, {
      path: 'catalogos',
      canActivate: [AuthGuardService],
      loadChildren: './catalogos/catalogos.module#CatalogosModule'
    }, {
      path: 'noticias',
      canActivate: [AuthGuardService],
      loadChildren: './noticias/noticias.module#NoticiasModule'
    }, {
      path: 'clasificados',
      canActivate: [AuthGuardService],
      loadChildren: './anuncios/anuncios.module#AnunciosModule'
    }, {
      path: 'reportes',
      canActivate: [AuthGuardService],
      loadChildren: './reportes/reportes.module#ReportesModule'
    }, {
      path: 'elements',
      canActivate: [AuthGuardService],
      loadChildren: './elements/elements.module#ElementsModule'
    }, {
      path: 'layouts',
      canActivate: [AuthGuardService],
      loadChildren: './layouts/layouts.module#LayoutsModule'
    }, {
      path: 'forms',
      canActivate: [AuthGuardService],
      loadChildren: './forms/forms.module#FormsModule'
    }, {
      path: 'charts',
      canActivate: [AuthGuardService],
      loadChildren: './charts/charts.module#ChartsModule'
    }, {
      path: 'tables',
      canActivate: [AuthGuardService],
      loadChildren: './tables/tables.module#TablesModule'
    }, {
      path: 'maps',
      canActivate: [AuthGuardService],
      loadChildren: './maps/maps.module#MapsModule'
    }, {
      path: 'pages',
      canActivate: [AuthGuardService],
      loadChildren: './pages/pages.module#PagesModule'
    }
  ]},
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'lock', component: LockComponent },
  { path: 'recover', component: RecoverComponent },

  // Not found
  { path: '**', redirectTo: 'dashboard' }
];



// WEBPACK FOOTER //
// ./src/app/routes/routes.ts